import React from "react";

import "./Home.scss";

export default function Home() {
  return (
    <div className="home">
      <div className="tagline">
        <h1>
          TOTAL LOGISTICS <br /> PROVIDER.
        </h1>
        <p>
          <a
            href="https://mail.google.com/mail/u/0/#inbox"
            target="_blank"
            rel="noopener noreferrer"
          >
            Call Us Now!
          </a>
        </p>
      </div>
    </div>
  );
}
